<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s9yWR8/images/9780312363925.jpg?1712288212472" alt="This image is the cover for the book Blood Vines"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood Vines
      </h1>
      <p class="bookDescription body article font2">
        <p>In this bare-knuckled adrenaline ride from New York Times bestselling author Erica Spindler, Alex Clarkson's worst nightmares are about to come true…<br/><br/><b>A sinister, hooded figure…</b><br/><br/>When Alexandra Clarkson starts having terrifying visions filled with blood and ceremonial images, she tries to find a rational explanation – maybe her mind is playing tricks on her, resurrecting creepy tableaux from her research on religious ceremonies and sects.  But when Alex's mother, Patsy, commits suicide without leaving behind any information, Alex is left wondering: could she be haunted by something from the childhood she doesn't remember?<br/><br/><b>Naked, writhing bodies…</b><br/><br/>Detective Daniel Reed was the last person to speak to Patsy.  What he reveals to Alex is shocking. Twenty-five years earlier, Patsy was married to Harlan Sommer, one of Sonoma County's most prominent vintners, when their infant son disappeared without a trace.  The loss destroyed the Sommers' marriage, causing Patsy to leave and take Alex with her.<br/><br/><b>A dead child…</b><br/><br/>Called on to investigate the identity of a baby's remains unearthed in a Sonoma vineyard, Reed had picked up a trail that led him to Patsy in San Francisco.  Now Reed and Alex both wonder if the cold bones could be her baby brother Dylan, and Alex decides to accompany Reed back to Sonoma for the investigation.  No sooner does she arrive, however, than she is drawn deep into the search for a twisted killer…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erica Spindler
      </h2>
      
      <p class="authorDescription body article"><P><I>New York Times</I> bestselling author <B>Erica Spindler</B> has written many novels, including <I>Breakneck</I>, <I>Watch Me Die</I>, <I>Bone Cold</I>, <I>In Silence</I> and <I>Last Known Victim</I>. Her books are published in 25 countries. Raised in Rockford, Illinois, Spindler planned on becoming an artist, and earned visual arts degrees from Delta State University and the University of New Orleans. But one day in 1982, she picked up a romance novel and was immediately hooked. She soon tried to write her own romance, but it was when she leapt from romance to suspense that she found her true calling. Spindler has won the prestigious Daphne du Maurier Award for excellence, the Kiss of Death Award, and has been a three-time RITA Award Finalist. She lives just outside New Orleans, Louisiana, with her husband and two sons.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f87d95a